import { parseFontVariant } from './parseFontVariant';

export function compareFontVariants(a: string, b: string): number {
  const aInfo = parseFontVariant(a);
  const bInfo = parseFontVariant(b);

  if (aInfo.fontWeight !== bInfo.fontWeight) {
    return aInfo.fontWeight - bInfo.fontWeight;
  }

  if (aInfo.fontStyle === 'normal' && bInfo.fontStyle === 'italic') {
    return -1;
  }

  if (aInfo.fontStyle === 'italic' && bInfo.fontStyle === 'normal') {
    return 1;
  }

  return 0;
}
